<ng-container *ngIf="image">
  <div class="i-column" [ngStyle]="getAreaStyle()">
    <ng-container *ngIf="image.isDummy">
      <div [style]="divStyle + dummyStyle" [style.width]="maxWidth + 'mm'" [style.line-height]="maxHeight + 'mm'">No Picture Available</div>
    </ng-container>

    <ng-container *ngIf="!image.isDummy">
      <img id="{{ image.id }}" class="column-image" [ngStyle]="getImageStyle(image)" [src]="image.src" (click)="clickImage(image.id)" />
    </ng-container>
  </div>
</ng-container>
